module.exports = __webpack_public_path__ + "static/img/11.e45db80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/11.jpg
// module id = M55U
// module chunks = 0